module.exports = __webpack_public_path__ + "img/flipRight.5e7e195f.png";